import React from "react";
import { Button } from "reactstrap";
import "./style.css";

const WhiteButton = ({ className = "", label, ...props }) => {
  return (
    <Button
      {...props}
      className={`footer-buttons text-capitalize outline-button-blue-color text-blue-color backgroundWhiteBtn white-button--secondary ${className}`}
    >
      {label}
    </Button>
  );
};

export default WhiteButton;
